// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroBG {
    display: flex;
    height: 608px;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.logo-hero-home {
    width: 200px;
}

.hero-content {
    text-align: center;
    justify-content: center;
}

.hero-content > p {
    max-width: 800px;
    margin-bottom: 2.5rem;
}

.hero-content h2, .hero-content h1 {
    margin: 0;
}

@media screen and (max-width: 1024px) {
    .logo-hero-home {
        width: 124px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/HeroBG.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".HeroBG {\n    display: flex;\n    height: 608px;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n.logo-hero-home {\n    width: 200px;\n}\n\n.hero-content {\n    text-align: center;\n    justify-content: center;\n}\n\n.hero-content > p {\n    max-width: 800px;\n    margin-bottom: 2.5rem;\n}\n\n.hero-content h2, .hero-content h1 {\n    margin: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .logo-hero-home {\n        width: 124px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
